module.exports = __webpack_public_path__ + "static/media/graph.9c2b0d32.svg";